module.exports = __webpack_public_path__ + "static/media/header-hero-left.d52e0fea.png";